import { useState, useEffect, useContext, useCallback } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ProgressSpinner } from 'primereact/progressspinner';
import { BarrioContext } from '../components/BarrioContext';
import { useAuth } from '../components/AuthContext';
import { getLiquidacionesBarrio, urlDescargarLiquidacionPdf } from '../service/LiquidacionBarrioPdfService';

const formatPeriodo = (p) => {
    if (!p) return '';
    const d = new Date(p);
    const label = d.toLocaleDateString('es-AR', { month: 'long', year: 'numeric' });
    return label.charAt(0).toUpperCase() + label.slice(1);
};

const formatFecha = (f) => f ? new Date(f).toLocaleDateString('es-AR') : '';

const ExpensasBarrio = () => {
    const { barrio } = useContext(BarrioContext);
    const { administracionId } = useAuth();

    const usuarioId = (() => { try { const u = JSON.parse(localStorage.getItem('user') || '{}'); return u.id || u.usuarioId || 0; } catch { return 0; } })();

    const [liquidaciones, setLiquidaciones] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchLiquidaciones = useCallback(async () => {
        if (!barrio?.id) return;
        setLoading(true);
        try {
            const { data } = await getLiquidacionesBarrio(barrio.id, administracionId);
            setLiquidaciones(data ?? []);
        } catch {
            setLiquidaciones([]);
        } finally {
            setLoading(false);
        }
    }, [barrio?.id, administracionId]);

    useEffect(() => { fetchLiquidaciones(); }, [fetchLiquidaciones]);

    const descargarBody = (row) => (
        <Button
            label="Descargar PDF"
            icon="pi pi-file-pdf"
            className="p-button-sm"
            onClick={() => window.open(urlDescargarLiquidacionPdf(barrio.id, row.periodo, administracionId, usuarioId), '_blank')}
        />
    );

    if (!barrio?.id) {
        return (
            <div className="flex flex-column align-items-center justify-content-center" style={{ minHeight: '50vh', textAlign: 'center' }}>
                <i className="pi pi-map-marker" style={{ fontSize: '2.5rem', color: '#98a2b3', marginBottom: '1rem' }} />
                <h4 style={{ margin: 0 }}>Seleccioná un barrio</h4>
            </div>
        );
    }

    return (
        <>
            <h4>Expensas</h4>
            <br />

            {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
                    <ProgressSpinner style={{ width: 48, height: 48 }} strokeWidth="4" />
                </div>
            ) : (
                <div className="grid">
                    <div className="col-12">
                        <DataTable
                            value={liquidaciones}
                            paginator
                            rows={12}
                            rowsPerPageOptions={[12, 24, 50]}
                            responsiveLayout="scroll"
                            emptyMessage="Todavía no hay liquidaciones de expensas disponibles"
                            sortField="periodo"
                            sortOrder={-1}
                            style={{ fontSize: '0.88rem' }}
                        >
                            <Column field="periodo" header="Período" sortable body={(r) => formatPeriodo(r.periodo)} style={{ minWidth: 150 }} />
                            <Column field="fechaGeneracion" header="Fecha de generación" sortable body={(r) => formatFecha(r.fechaGeneracion)} style={{ minWidth: 160 }} />
                            <Column header="" body={descargarBody} style={{ minWidth: 170 }} />
                        </DataTable>
                    </div>
                </div>
            )}
        </>
    );
};

export default ExpensasBarrio;
